export default __webpack_public_path__ + "static/media/data.bfb0c14f.gif";